import { useAppSelector } from 'store/useAppSelector';

import { MAINTENANCE_TOP_BANNER, MAX_TOP_BANNERS } from '../constants';
import { selectClosedTopBanners } from '../store/selectors';
import { useFetchTopBannersQuery } from '../actions/fetchTopBanners';
import { useTopBannerUsers } from './useTopBannerUsers';

export const useCurrentTopBanners = () => {
  const { data } = useFetchTopBannersQuery();

  const { loaded, users } = useTopBannerUsers();

  const closedBanners = useAppSelector(selectClosedTopBanners);

  const topBanners = [MAINTENANCE_TOP_BANNER, ...(data ?? [])]
    .filter(
      banner =>
        banner.isVisible &&
        users.includes(banner.users) &&
        !closedBanners.includes(banner.id),
    )
    .slice(0, MAX_TOP_BANNERS);

  return { loaded, topBanners };
};
